/**
 * https://github.com/probil/v-mask
 * 输入框文本内置遮罩指令, 限定输入框的文本按给定格式输入
 * 使用方法: v-mask="'(+86) ###-####-####'"
 * 说明:	# 表示数字0-9
 * 			A 表示字母a-z/A-Z
 * 			N 表示字母或数字
 * 			X 表示任意符号
 * 			? 表示可选符号(下一个字符)
 */

const inBrowser = typeof window !== 'undefined';
const UA = inBrowser && window.navigator.userAgent.toLowerCase();
const isEdge = UA && UA.indexOf('edge/') > 0;
const isAndroid = UA && UA.indexOf('android') > 0;
const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

const trigger = (el: HTMLInputElement, type: string) => {
	const e = document.createEvent('HTMLEvents');
	e.initEvent(type, true, true);
	el.dispatchEvent(e);
};
const queryInputElementInside = (el: any) => (el instanceof HTMLInputElement ? el : el.querySelector('input') || el);

const format = (text: string, wholeMask?: string) => {
	if (!wholeMask) return text;

	const maskStartRegExp = /^([^#ANX]+)/;

	if (+text.length === 1 && maskStartRegExp.test(wholeMask)) {
		text = (maskStartRegExp.exec(wholeMask) || [])[0] + text;
	}

	let newText = '';
	let charOffset = 0;

	// Cleans data to  avoid value loss on dynamic mask changing
	for (let maskIndex = 0; maskIndex < wholeMask.length; maskIndex += 1) {
		const mask = wholeMask.charAt(maskIndex);
		switch (mask) {
			case '#':
				break;
			case 'A':
				break;
			case '?':
				break;
			case 'N':
				break;
			case 'X':
				break;
			default:
				text = text.replace(mask, '');
		}
	}
	for (let maskIndex = 0, x = 1; x && maskIndex < wholeMask.length; maskIndex += 1) {
		const char = text.charAt(maskIndex - charOffset);
		const mask = wholeMask.charAt(maskIndex);

		switch (mask) {
			case '#':
				/\d/.test(char) ? (newText += char) : (x = 0);
				break;
			case 'A':
				/[a-z]/i.test(char) ? (newText += char) : (x = 0);
				break;
			case 'N':
				/[a-z0-9]/i.test(char) ? (newText += char) : (x = 0);
				break;
			// Skips testing if optional field is specified
			case '?':
				charOffset += 1;
				break;
			case 'X':
				newText += char;
				break;
			default:
				newText += mask;

				// preserve characters that are in the same spot we need to insert a mask
				// character by shifting the data over to the right (issue #5, & #7)
				if (char && char !== mask) {
					text = ` ${text}`;
				}

				break;
		}
	}
	return newText;
};

const updateValue = (el: HTMLInputElement, force = false) => {
	const { value, dataset: { previousValue = '', mask } } = el;

	if (force || (value && value !== previousValue && value.length > previousValue.length)) {
		(el as HTMLInputElement).value = format(value, mask);
		if (isAndroid && isChrome) {
			setTimeout(() => trigger(el, 'input'), 0);
		} else {
			trigger(el, 'input');
		}
	}

	el.dataset.previousValue = value;
};

const updateMask = (el: HTMLInputElement, mask: any) => {
	// change format
	el.dataset.mask = mask;
};

export default {
	bind (el: HTMLElement | HTMLInputElement, binding: any, vnode: any) {
		const input: HTMLInputElement = queryInputElementInside(el);

		updateMask(input, binding.value);
		updateValue(input);
	},
	componentUpdated (el: HTMLElement | HTMLInputElement, binding: any, vnode: any) {
		const input: HTMLInputElement = queryInputElementInside(el);

		const isMaskChanged = binding.value !== binding.oldValue;

		// update mask first if changed
		if (isMaskChanged) {
			updateMask(input, binding.value);
		}

		// update value
		updateValue(input, isMaskChanged);
	},
	unbind (el: HTMLElement, binding: any, vnode: any) {},
};
